const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/members/invite/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { queryParamsSchema } from "@/react/components/SettingsApp/ManageMembers/InviteMembers/queryParamsSchema";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/members/invite")({
  validateSearch: queryParamsSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});